import { render, staticRenderFns } from "./aboutOus.vue?vue&type=template&id=d410e34a&"
import script from "./aboutOus.vue?vue&type=script&lang=js&"
export * from "./aboutOus.vue?vue&type=script&lang=js&"
import style0 from "./aboutOus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports